export default __webpack_public_path__ + "media/images/backgrounds/green-vegetables-bg-00d809e565f1a2363cfb7c7152286b3d.svg";